import type { ReactNode } from 'react';

import {
  Drawer,
  DrawerBody,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from '@virginexperiencedays/components-v2/src/layout/Drawer';
import { IconCloseModal } from '@virginexperiencedays/components-v2/src/icons/IconCloseModal';
import { SectionHeading } from '@virginexperiencedays/components-v2/src/typography/SectionHeading';

import type { CollectionChoiceDrawerModalSharedProps } from './types';

export const CollectionChoiceDrawer = ({
  children,
  collectionTitle,
  isOpen,
  setIsOpen,
  onClose,
}: CollectionChoiceDrawerModalSharedProps) => {
  return (
    <Drawer open={isOpen} onOpenChange={setIsOpen} noBodyStyles disablePreventScroll>
      <DrawerContent hasHandle>
        <DrawerDescription className="sr-only">Product content:</DrawerDescription>
        <CollectionChoiceDrawerHeader onClose={onClose}>
          {collectionTitle}
        </CollectionChoiceDrawerHeader>
        <DrawerBody className="pt-0">{children}</DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

const CollectionChoiceDrawerHeader = ({
  children,
  onClose,
}: {
  children: ReactNode;
  onClose: () => void;
}) => {
  return (
    <DrawerHeader className="flex items-center">
      <DrawerTitle className="flex-1">
        <SectionHeading>{children}</SectionHeading>
      </DrawerTitle>
      <DrawerClose className="px-2" onClick={onClose}>
        <IconCloseModal />
      </DrawerClose>
    </DrawerHeader>
  );
};
